import { IthemeColorSet } from '@typings/setting/themeColor.interface';
import { atom } from 'recoil';

export const globalStyleState = atom<any>({
  key: 'globalStyleState',
  default: {
    backgroundColor: '',
  },
});

export const globalBgEffectActiveState = atom<boolean>({
  key: 'globalBgEffectActiveState',
  default: true,
});

// background 설정 할지말지 고민중
export const themeSetState = atom<IthemeColorSet>({
  key: 'themeSetState',
  default: {},
});
